module.exports = __webpack_public_path__ + "static/media/440531659_1635580427282922_4402485410406019862_n.a526196e.jpg";